import { render } from "./personal-info.vue?vue&type=template&id=5dd1d5a1"
import script from "./personal-info.vue?vue&type=script&lang=js"
export * from "./personal-info.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__